import React from "react";
import { useLocation } from "react-router-dom";
import {
  DropMenuContainer,
  Icon,
  CloseIcon,
  DropMenuWrapper,
  DropMenuList,
  DropMenuLink,
  BtnWrap,
  NavButton,
} from "./DropMenuElements";

const DropMenu = ({ isOpen, toggle }) => {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  const sectionLinkProps = (section) =>
    isHomePage
      ? {
          to: section,
          smooth: true,
          duration: 500,
          spy: true,
          exact: "true",
          offset: -80,
        }
      : { as: "a", href: `/#${section}` };

  return (
    <DropMenuContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <DropMenuWrapper>
        <DropMenuList>
          <DropMenuLink onClick={toggle} {...sectionLinkProps("about")}>
            About
          </DropMenuLink>
          <DropMenuLink onClick={toggle} {...sectionLinkProps("services")}>
            Services
          </DropMenuLink>
          <DropMenuLink as="a" href="/contact" onClick={toggle}>
            Contact
          </DropMenuLink>
          <BtnWrap>
            <NavButton
              href="https://outlook.office.com/bookwithme/user/bb51bbe3bc3d4e3eb0635e8990c6ad0b@shift-it.io?anonymous&ep=plink"
              primary={true}
              dark={true}
              target="_blank"
            >
              Book a 15-minute Fit Check
            </NavButton>
          </BtnWrap>
          <BtnWrap style={{ display: "none" }}>
            <NavButton
              href="https://portal.shift-it.io"
              primary={true}
              dark={true}
              target="_blank"
            >
              Client Portal
            </NavButton>
          </BtnWrap>
        </DropMenuList>
      </DropMenuWrapper>
    </DropMenuContainer>
  );
};

export default DropMenu;
